import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { asString } from "@/components/shapes/shared/plain-record";
import { frameDisplayTitle } from "@/lib/frame-display-title";
import { frameProjectId } from "@/lib/frame-project";
import { ChartEmpty, ChartEmptyLine } from "./chart-empty";
import { ChartFace } from "./chart-face";
import {
  chartKindFrom,
  chartPointsFrom,
  chartSourceFrom,
} from "./chart-points";

const MAX_BARS = 12;

/**
 * A chart: its face (`ChartFace`, by its kind) over its latest points, or a
 * ghost of its kind and when it fills while it has none.
 */
export function ChartCardPreview({ frame, source, density }: CardPreviewProps) {
  const kind = chartKindFrom(source.kind);
  const points = chartPointsFrom(source.points);
  return (
    <ChartFace
      kind={kind}
      title={asString(source.title) || frameDisplayTitle(frame)}
      unit={asString(source.unit)}
      // One number keeps its whole period: its first label is the start.
      points={kind === "number" ? points : points.slice(-MAX_BARS)}
      density={density}
      testIdPrefix="chart-card"
      empty={
        <ChartEmpty kind={kind} testId="chart-card-ghost">
          <p
            className="m-auto text-center text-[0.84em] text-card-muted"
            data-testid="chart-card-empty"
          >
            <ChartEmptyLine
              source={chartSourceFrom(source.source)}
              projectId={frameProjectId(frame)}
            />
          </p>
        </ChartEmpty>
      }
    />
  );
}
